const hasField = {
  install (Vue, options) {
    Vue.directive('hasField', {
      bind (el, binding) {
        console.log(binding.value.b)
        if (!binding.value.b.includes(binding.value.a)) {
          el.parentNode.readonly = true
        }
      },
      update (el, binding) {
        console.log(binding.value.b)
        if (!binding.value.b.includes(binding.value.a)) {
          console.log(el.parentNode)
          el.parentNode.readonly = true
        }
      }
    })
  }
}

export default hasField



// WEBPACK FOOTER //
// ./src/libs/hasField.js